import { render, staticRenderFns } from "./salesMaterialPrice.vue?vue&type=template&id=ff157638&scoped=true&"
import script from "./salesMaterialPrice.vue?vue&type=script&lang=js&"
export * from "./salesMaterialPrice.vue?vue&type=script&lang=js&"
import style0 from "./salesMaterialPrice.vue?vue&type=style&index=0&id=ff157638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff157638",
  null
  
)

export default component.exports